import { useState } from 'react';
import './NavigationDrawer.scss';
import { NavigationElement } from './NavigationElement';
import {
    AccountsIcon,
    CurrencyIcon,
    DashboardIcon,
    MilestonesIcon,
    ProjectsIcon,
    SettingsIcon,
    TaxIcon,
    TimelineIcon,
    TransactionsIcon,
} from './icons';

const PRIMARY_ITEMS = [
    { title: 'Dashboard',    path: '/dashboard',    Icon: DashboardIcon },
    { title: 'Transactions', path: '/transactions', Icon: TransactionsIcon },
    { title: 'Milestones',   path: '/milestones',   Icon: MilestonesIcon },
    { title: 'Timeline',     path: '/timeline',     Icon: TimelineIcon },
];

const SECONDARY_ITEMS = [
    { title: 'Accounts', path: '/accounts', Icon: AccountsIcon },
    { title: 'Projects', path: '/projects', Icon: ProjectsIcon },
    { title: 'Currency', path: '/currency', Icon: CurrencyIcon },
    { title: 'Tax',      path: '/tax',      Icon: TaxIcon },
];

const NavigationDrawer = () => {
    const [subOpen, setSubOpen] = useState(false);

    return (
        <>
            <div className="navigation-drawer-container">
                <aside className="navigation-drawer" aria-label="Navigation">
                    {PRIMARY_ITEMS.map(({ title, path, Icon }) => (
                        <NavigationElement key={path} title={title} path={path} Icon={Icon} onClick={_ => setSubOpen(false)} />
                    ))}

                    <div className="navigation-drawer__divider" />

                    <div className="navigation-drawer__secondary">
                        {SECONDARY_ITEMS.map(({ title, path, Icon }) => (
                            <NavigationElement key={path} title={title} path={path} Icon={Icon} onClick={_ => setSubOpen(false)}/>
                        ))}
                    </div>

                    <button
                        className={`navigation-element${subOpen ? ' is-active' : ''} navigation-drawer__settings-btn`}
                        onClick={(e) => { setSubOpen(v => !v); e.currentTarget.blur(); }}
                        aria-label="More navigation"
                        aria-expanded={subOpen}
                    >
                        <SettingsIcon className="wallet-icon" />
                        <span className="navigation-element__title navigation-drawer__settings-label">Setup</span>
                    </button>
                </aside>

                <nav
                    className={`navigation-drawer__sub${subOpen ? ' is-open' : ''}`}
                    aria-label="More navigation"
                    aria-hidden={!subOpen}
                    onClick={() => setSubOpen(false)}
                >
                    {SECONDARY_ITEMS.map(({ title, path, Icon }) => (
                        <NavigationElement key={path} title={title} path={path} Icon={Icon} onClick={_ => setSubOpen(false)}/>
                    ))}
                </nav>

                <div className="navigation-drawer__overlay" aria-hidden="true" />
            </div>

            {subOpen && (
                <div
                    className="navigation-drawer__sub-backdrop"
                    onClick={() => setSubOpen(false)}
                    aria-hidden="true"
                />
            )}
        </>
    );
};

export default NavigationDrawer;